Location information of the choice.
